/* Warenkorb-Zustand: echter Shopify-Warenkorb über die AJAX-API (/cart.js, /cart/add.js, /cart/change.js).
   Preise, Staffel-Rabatte und Geschenke rechnet Shopify. Hier wird nur gelesen, hinzugefügt und geändert. */
(function () {
  const D = window.ZY;
  const R = Object.assign({ root: '/', cart: '/cart' }, D.routes);
  const url = p => R.root.replace(/\/$/, '') + p;
  const blank = { items: [], item_count: 0, total_price: 0, original_total_price: 0, items_subtotal_price: 0, total_discount: 0, cart_level_discount_applications: [] };

  let state = blank;
  const subs = new Set();
  const cents = v => (v || 0) / 100;

  function totals() {
    const total = cents(state.total_price);
    const original = cents(state.original_total_price);
    const unlocked = D.thresholds.filter(t => total >= t.amount);
    const next = D.thresholds.find(t => total < t.amount) || null;
    // Raumdüfte im Warenkorb (für den Staffel-Vorschlag)
    const roomIds = new Set(D.scents.map(s => s.variant).filter(Boolean));
    const roomQty = state.items.filter(i => roomIds.has(i.variant_id)).reduce((a, i) => a + i.quantity, 0);
    let upsell = null;
    const maxTier = D.tiers[D.tiers.length - 1].qty;
    if (roomQty > 0 && roomQty < maxTier) {
      const now = D.tier(roomQty), then = D.tier(roomQty + 1);
      const inCart = new Set(state.items.map(i => i.variant_id));
      const first = D.scents.find(s => s.variant === (state.items.find(i => roomIds.has(i.variant_id)) || {}).variant_id);
      const pool = D.scents.filter(s => !s.soldOut && !inCart.has(s.variant));
      const same = pool.filter(s => first && s.moment === first.moment);
      // Vorschlag: am liebsten ein neuer Duft, sonst ein schon gewählter (zweimal derselbe ist erlaubt)
      const scent = (same[0] || pool[0] || D.scents.find(s => !s.soldOut) || {}).id;
      if (now && then && scent) upsell = { from: roomQty, to: roomQty + 1, delta: Math.round((then.price - now.price) * 100) / 100, scent };
    }
    return {
      total, original, merch: total,
      savings: Math.max(0, Math.round((original - total) * 100) / 100),
      shipping: D.thresholds.some(t => t.key === 'shipping') ? (unlocked.some(t => t.key === 'shipping') ? 0 : null) : null,
      unlocked, next, roomQty, upsell, items: state.item_count
    };
  }

  function emit(meta) { const t = totals(); subs.forEach(fn => fn(state, t, meta || {})); }

  async function request(path, body, extraHeaders) {
    const res = await fetch(url(path), {
      method: body ? 'POST' : 'GET',
      headers: Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, extraHeaders || {}),
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Warenkorb nicht erreichbar');
    return data;
  }

  async function refresh(meta) {
    state = await request('/cart.js');
    emit(meta);
    return state;
  }

  // items: [{ id: variantId, quantity }]
  async function add(items, meta) {
    items = items.filter(i => i && i.id);
    if (!items.length) throw new Error('Dieser Artikel ist gerade nicht verfügbar.');
    const merged = {};
    items.forEach(i => { merged[i.id] = (merged[i.id] || 0) + (i.quantity || 1); });
    const res = await request('/cart/add.js', { items: Object.keys(merged).map(id => ({ id: Number(id), quantity: merged[id] })) });
    const added = (res.items || []).map(i => i.key);
    // Geschenke und Rabatte können sich geändert haben: vollständigen Warenkorb neu laden
    await refresh(Object.assign({ added }, meta));
    return added;
  }

  async function setQty(key, quantity) {
    state = await request('/cart/change.js', { id: key, quantity: Math.max(0, Math.min(quantity, 20)) });
    emit({ changed: key });
  }

  // Geschenk-Sorte tauschen: Wahl merken (für den Geschenk-Schutz) und die Zeile ersetzen.
  // Mit dem Guard-Header, damit der Geschenk-Schutz den Zwischenstand ohne Geschenk nicht korrigiert.
  async function swapGift(key, productId, variantId) {
    const G = window.ZYD_GIFTS;
    const h = G ? { [G.header]: '1' } : {};
    try {
      const choice = JSON.parse(localStorage.getItem(G ? G.choiceKey : 'zyd_gift_choice') || '{}') || {};
      choice[productId] = variantId;
      localStorage.setItem(G ? G.choiceKey : 'zyd_gift_choice', JSON.stringify(choice));
    } catch (e) { /* privater Modus */ }
    await request('/cart/change.js', { id: key, quantity: 0 }, h);
    await request('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] }, h);
    await refresh({ changed: key });
  }

  // Rabattcodes setzen (ersetzt die Liste; leere Liste entfernt alle). Shopify meldet in cart.discount_codes, ob ein Code greift.
  async function setCodes(codes) {
    await request('/cart/update.js', { discount: codes.filter(Boolean).join(',') });
    await refresh({ codes: true });
    return state.discount_codes || [];
  }

  function subscribe(fn) { subs.add(fn); fn(state, totals(), { initial: true }); return () => subs.delete(fn); }

  refresh({ initial: true }).catch(() => {});
  // Andere Skripte (z. B. Geschenk-Schutz, Apps) ändern den Warenkorb: beim Zurückkehren in den Tab neu laden
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh().catch(() => {}); });

  window.ZYStore = { get state() { return state; }, totals, subscribe, add, setQty, remove: key => setQty(key, 0), refresh, swapGift, setCodes };
})();
